import React from 'react'
import './EmailBar.scss'

function EmailBar() {
    return (




        <div className="EmailBar__container">
            <a className='bar__email ' href="mailto:azizrezgui4@gmail.com">azizrezgui4@gmail.com</a>
            <span className="bar"></span>
        </div>






    )
}

export default EmailBar
